import {Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Store} from "@ngrx/store";
import { ToastrService } from 'ngx-toastr';
import { ITask } from 'src/app/models';
import { DealService } from 'src/app/modules/deals/services';
import { toggleLoading } from 'src/app/modules/redux';
import { IDealCard } from 'src/app/modules/shared/models';
import { UtilService } from 'src/app/modules/shared/services';
import { AppConfigService } from 'src/app/services';
import { DataService } from 'src/app/services/data/data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  // tasks$: Observable<ITask[]>;
  environment = environment;
  tasks: ITask[] = []
  // deals$: Observable<IDealCard[]>;
  pendingDeals: IDealCard[] = [];
  liveDeals: IDealCard[] = [];
  userActivity: IUserActivity[] = [];

  constructor(
    private toastr: ToastrService,
    private router: Router,
    // private activatedRoute: ActivatedRoute,
    private store: Store,
    private dataService: DataService,
    private dealService: DealService,
    private configService: AppConfigService,
    public util: UtilService) { 

    }

  ngOnInit(): void {
   
    this.configService.getTasks().subscribe({
      next: (tasks: ITask[]) => {
        this.tasks = tasks;

        if (this.tasks.length == 0) {
          // there are no tasks get deals
          this.getDeals();
        }
      }
    });

    this.configService.getUserActivity().subscribe({
      next: (activity: any[]) => {
        this.userActivity = activity as IUserActivity[];
      }
    });
   
  }

  viewLiveDeals() {
    this.store.dispatch(toggleLoading({loading: true}));
    this.router.navigate(["/", this.dataService.getBuSlug(), "deals"], { queryParams: { status: 'live' } }).then(() => {
      this.store.dispatch(toggleLoading({loading: false}));
    });
  }

  viewPendingDeals() {
    this.store.dispatch(toggleLoading({loading: true}));
    this.router.navigate(["/", this.dataService.getBuSlug(), "deals"], { queryParams: { status: 'pending,declined,onboarding' } }).then(() => {
      this.store.dispatch(toggleLoading({loading: false}));
    });
  }

  getDeals() {
    this.dealService.getDeals().subscribe({
      next: (deals: IDealCard[]) => {
        this.liveDeals = deals.filter(x => x.dealWorkflow == "LIVE");

        if (this.util.isIssuer()) {
          // if there are pending deals, go to the pending 
          this.pendingDeals = deals.filter(x => x.dealWorkflow == "PENDING" || x.dealWorkflow == "ONBOARDING" || x.dealWorkflow == "DECLINED");
        }
      }
    })
  }

  clickItem(task: ITask) {
    console.log("Click Task", task);

    // if there is no route, return;
    if (!task.route) {
      return;
    }
    
    var routeArray = [this.dataService.getBuSlug(), task.route];

    if (!!task.routeId) {
      var splt = task.routeId.split("/");
      splt.forEach(x => {
        if (!!x) {
          routeArray.push(x);
        }
      })
    }

    if (!!task.fragment)
      routeArray.push(task.fragment);

    this.store.dispatch(toggleLoading({loading: true}));
    this.router.navigate(routeArray, { queryParams: task.queryParams }).then(() => {
      this.store.dispatch(toggleLoading({loading: false}));
    })
  }



}

export interface IUserActivity {
  id: number;
  appUserId: string;
  buid: string;
  sbuid: string;
  message: string;
  created: Date;
}